(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('listFilterSelect', listFilterSelect);

    function listFilterSelect() {
        return {
            restrict: 'E',
            scope: {
                item: '=',
                disabled: '=?',
            },
            templateUrl: 'common/components/select',
            controller:listFilterSelectCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function listFilterSelectCtrl(SELECT_CONSTANT, $scope) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.constant = SELECT_CONSTANT;

            vm.toggleSelect = toggleSelect;
        }

        function toggleSelect() {
            if (!vm.disabled) {
                vm.item.selected =
                    (vm.item.selected == SELECT_CONSTANT.SELECTED)
                        ? SELECT_CONSTANT.NOT_SELECTED
                        : SELECT_CONSTANT.SELECTED;
                $scope.listFilterService.toggleSelectRow(vm.item);
            }
        }
    }
})();